var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8546 12.72C15.9953 12.5795 16.0744 12.3888 16.0746 12.19V11.81C16.0723 11.6116 15.9935 11.4217 15.8546 11.28L10.7146 6.14997C10.6207 6.05532 10.4929 6.00208 10.3596 6.00208C10.2263 6.00208 10.0985 6.05532 10.0046 6.14997L9.29462 6.85997C9.20055 6.95214 9.14754 7.07828 9.14754 7.20997C9.14754 7.34166 9.20055 7.46781 9.29462 7.55997L13.7446 12L9.29462 16.44C9.19996 16.5339 9.14672 16.6617 9.14672 16.795C9.14672 16.9283 9.19996 17.0561 9.29462 17.15L10.0046 17.85C10.0985 17.9446 10.2263 17.9979 10.3596 17.9979C10.4929 17.9979 10.6207 17.9446 10.7146 17.85L15.8546 12.72Z",
    fill: "#2E3896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.8f49ee5494822870dbf37032e98541f1.svg";
export { ForwardRef as ReactComponent };